import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '$store';
import useAppDispatch from '~hooks/useAppDispatch';
import { resetSelectedFields, setProcessInProgress } from '~modules/media-library/controller/thunks/contribute';

interface ContributionDoneProps {
  continueButton?: boolean;
  onStepComplete?: () => void;
  onClose?: () => void;
}

const ContributionDone = ({ continueButton, onStepComplete, onClose }: ContributionDoneProps) => {
  const data = useSelector((store: RootState) => store.contribute);
  const { selectedAssetIds, currentAssetId } = data;
  let message: string = '';
  if ('message' in data.contribution) {
    message = data.contribution.message as string;
  }

  const dispatch = useAppDispatch();

  const latestItem = currentAssetId === selectedAssetIds[selectedAssetIds.length - 1];

  const renderSecondMessage = message.includes('review');

  useEffect(() => {
    if (!continueButton) {
      dispatch(setProcessInProgress(false));
    }
  }, [continueButton, dispatch]);

  useEffect(() => {
    dispatch(resetSelectedFields());
  }, [latestItem, dispatch]);

  return (
    <div
      style={{ '--custom-height': '550px' } as React.CSSProperties}
      className="h-custom  flex flex-col justify-center items-center text-center"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 mb-4" viewBox="0 0 48 49" fill="none">
        <path
          d="M44 22.66V24.5C43.9975 28.8128 42.601 33.0093 40.0187 36.4636C37.4363 39.9179 33.8066 42.4449 29.6707 43.6678C25.5349 44.8906 21.1145 44.7438 17.0689 43.2491C13.0234 41.7545 9.56931 38.9922 7.22192 35.3741C4.87453 31.756 3.75958 27.4761 4.04335 23.1726C4.32712 18.8691 5.99441 14.7726 8.79656 11.4941C11.5987 8.21561 15.3856 5.93074 19.5924 4.98026C23.7992 4.02979 28.2005 4.46465 32.14 6.21997"
          stroke="#078F2D"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M44 8.5L24 28.52L18 22.52"
          stroke="#078F2D"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <h2 className="text-xl font-semibold mb-2">{message}</h2>
      {renderSecondMessage && (
        <>
          <p className="text-sm text-gray-600">You will be kept informed of the progress via email.</p>

          <button
            type="button"
            className="h-10 button c-button c-button--light u-padding-horizontal-lg mx-2 mt-4"
            onClick={onClose}
          >
            OK
          </button>
        </>
      )}
      {continueButton && !latestItem && (
        <button
          type="button"
          className="h-10 button c-button c-button--light u-padding-horizontal-lg mx-2 mt-4"
          onClick={onStepComplete}
        >
          Continue
        </button>
      )}
    </div>
  );
};

export default ContributionDone;
